import WebIM from '@/utils/WebIM'
import config from '@/utils/WebIMConfig'
import router from "@/router";
import {
  getConcatToken,
  getMembers,
  getMembersById,
  getGroups,
  getGroup,
  saveRoster,
  joinGroup,
  getRosterById,
  exchangePosition
} from '@/api/request/concatService'
import { getCommonWords } from '@/api/request/commonService';
import store from '@/store'
import { asyncQueueFlush, stuSortUserOrGroup } from '@/utils/groupChat'
import { Message } from 'view-design'
import {
  getSessionList,
  getUserUnreadRecords,
  mixinMsgUnreadNum, singleCase,
  subscribeMsgNotice,
  updateUserUnreadMsgRecords, userInfoSessionListCompare
} from '@/utils/tool'
/* 函数柯里化 计算请求回调数 */
const resultFun = (maxLen, type, isFastExec, options) => {
  /* 是否立即执行 不参与回调 */
  if ( isFastExec ) {
    store.dispatch('groupOrSingleFristSortStu', { type, options })
    return
  }
  let i = 0
  return () => {
    ++ i
    if ( i >= maxLen ) {
      store.dispatch('groupOrSingleFristSortStu', { type, options })
    }
  }
}

/**
 * @description 导出企业聊天相关的actions
 */
export default {

  /**
   * @author lihh
   * @description 初期化获取用户 群组未读消息等
   * @param commit
   */
  async initGetUnreadMsgInfo({ commit }) {
    const res = await WebIM.conn.getSessionList(),
      { data: { channel_infos: initMsgInfo } } = res,
      groupUnreadInfo = [],
      singleUnreadInfo = [],
      idHandle = channel_id => (channel_id.substring(channel_id.indexOf('_') + 1, channel_id.indexOf('@')));

    /* 针对群聊以及单聊数据进行拆分 */
    (initMsgInfo || []).forEach(item => {
      if ( !item ) return true
      const { channel_id, unread_num } = item;
      (channel_id.endsWith('@easemob.com') ? singleUnreadInfo : groupUnreadInfo).push({
        id: idHandle(channel_id),
        unread_num
      })
    })

    groupUnreadInfo.length !== 0 && singleUnreadInfo.length !== 0
      ? commit('initGetUnreadMsgInfo', { singleUnreadInfo, groupUnreadInfo }) : null
    return true
  },
  updateUserList: function(context, payload) {
    context.commit('updateUserList', payload)
  },
  async updateJob(context, payload) {
    if ( !Reflect.has(payload, 'name') || !Reflect.has(payload, 'positionId') ) return
    const { name, positionId } = payload
    let params = {
      userId: name,
      positionId
    }
    let res = await exchangePosition(params)
    // 判断请求是否成功
    if ( res.code != 200 ) {
      return false
    }
    context.commit('updateJob', payload)
  },

  // 表示删除用户
  deleteUserStu: function(context, payload) {
    context.commit('deleteUserStu', payload)
  },

  // 环信登录
  imLogin(context, payload = {}) {
    const onLogin = () => {
      // 格式化后获取 缓存中的值
      const userInfo = localStorage.getItem('userInfo')
      if ( !userInfo ) return false
      // 解构数据
      // const { userId: user, accessToken } = JSON.parse(userInfo)
      // const { apiURL: apiUrl, appkey: appKey } = WebIM.config

      // 1.配置参数
      // 2.连接环信
      // const options = { apiUrl, user, accessToken, appKey }
      // WebIM.conn.open(options)

      /* 使用宏任务清空分页 */
      let timer = setTimeout(() => {
        if ( WebIM.conn.mr_cache ) WebIM.conn.mr_cache = []
        clearTimeout(timer)
        timer = null
      }, 1000)
    }
    // 解构数据 判断是请求还是刷新
    const { type, callback } = payload
    // 判断是否是请求
    if ( type === 'login' ) {
      // 请求环信的token
      getConcatToken().then(res => {
        callback && callback()
        // 判断是否请求成功
        if ( !res || res.code !== '200' ) return
        // 解构数据
        const { user: userId, nickName, accessToken, headImg } = res.data
        // localStorage保存数据
        localStorage.setItem('userInfo', JSON.stringify({ userId, nickName, accessToken, headImg }))
        /* 判断当前登录的用户 跟上次登录的用户是否一致 */
        const SameAccount = localStorage.getItem('SameAccount')
        if ( SameAccount !== userId ) {
          localStorage.setItem('SameAccount', userId)
          /* 删除聊天缓存 */
          // context.commit('clearChatAboutAllStatus')
        }
        // 进行登录
        onLogin()
        /* __loginInitLoading__ 用来表示环信登录后请求别的数据 __pushTimeout__ 用来延迟推送的  */
        singleCase.__loginInitLoading__ = singleCase.__pushTimeout__ = true
      })
    } else {
      // 进行登录
      onLogin()
    }
  },
  // 清除所有的用户和群聊
  clearAllUserOrGroupStu(context) {
    context.commit('clearAllUserOrGroupStu')
  },
  // 群组相关 加入
  currentGAllUserStu: function({ commit, state }, payload = {}) {
    // 判断属性是否存在 userId 存在表示单加  反之初期化查询
    if ( Reflect.has(payload, 'userId') ) {
      // 解构数据
      const { userId: id, groupId, callback = null } = payload
      /* 判断群聊是否当天聊天的群 */
      const currentId = localStorage.getItem('currentId')
      if ( currentId === groupId ) {
        const { currentGAllUser = [] } = state,
          localIndex = currentGAllUser.findIndex(item => item.id === id)
        if ( localIndex !== - 1 ) return
      }

      // 查询数据
      getMembersById({ id, groupId }).then(res => {
        // 判断请求是否成功
        if ( res.code != 200 ) {
          return
        }

        // 提交数据
        if ( currentId === groupId ) commit('currentGAllUserStu', res.data)
        // 执行成功回调  --添加成功后 发消息提醒
        callback && callback({ ...res.data, groupId })
      })
    } else {
      getMembers(payload['groupId']).then(res => {
        // 判断请求是否成功
        if ( res.code != 200 ) {
          // Toast.error(res.msg);
          return
        }
        // 提交数据
        commit('currentGAllUserStu', res.data)
      })
    }
  },

  // 群组 成员离开
  removeCGroupUserStu: function(context, payload) {
    // 解构数据
    const { groupId = null } = payload
    // 判断是否有值
    if ( !groupId ) {
      return
    }

    // 提交actions
    context.commit('removeCGroupUserStu', { ...payload })
  },

  /**
   * @author lihh
   * @description 删除群中的其他的用户
   * @param commit 表示提交的事件
   * @param payload
   */
  delCGroupOtherUser({ commit }, payload = {}) {
    // 解构数据
    const { groupId = null, userId = null } = payload
    // 判断是否有值
    if ( !groupId || !userId ) {
      return
    }

    // 当前聊天的群id
    let currentGroupId = window.localStorage.getItem('currentId')
    // 判断是否一致 如果不是本群聊天 不做任何处理
    if ( currentGroupId !== groupId ) {
      return
    }

    // 提交actions
    commit('delCGroupOtherUser', { ...payload })
  },

  /**
   * @description 查询所有的好友 或是 群聊
   * @param {*} commit 表示提交的事件
   * @param {*} payload 传递参数
   */
  async getGroupsInfo({ commit, dispatch }, payload = {}) {
    /* 设置参数 */
    const { groupName = '' } = payload,
      params = { groupName }

    /* 进行数据查询 */
    const res = await getGroups(params)
    // 判断数据是否查询成功
    if ( res.code !== '200' ) {
      subscribeMsgNotice('chat_groupLoading', '0')
      Message.error(res.msg)
      return
    }

    /* 判断数据是否为空 */
    if ( res.data.length === 0 ) {
      commit('settingGroupsInfo', { result: [] })
      subscribeMsgNotice('chat_groupLoading', '0')
      return
    }

    /* 获取环信的session list */
    const sessionList = await getSessionList(),
      newData = userInfoSessionListCompare(sessionList, res.data, 'hxGroupId', 2)

    /* 表示用户commit事件 */
    commit('settingGroupsInfo', { result: newData })
    // 获取对应群的历记录
    res.data.forEach(item => dispatch('getHistoryMessage', {
      name: item.hxGroupId,
      isGroup: true,
      count: 10
    }))
    subscribeMsgNotice('chat_groupLoading', '0')
  },

  /**
   * @author lihh
   * @description 对聊天的用户进行排序(包括单聊 以及群聊)
   *               1. 置顶用户永远在最上面
   *               2. 正常的按时间顺序排序
   *               3. 如果是单聊 如果没有这个用户添加用户
   * @param {*} commit 提交事件
   * @param {*} payload 需要排序的用户
   *            name 表示userId || groupId
   *            isSingle 是否单聊
   */

  async stuSortList(context, payload) {
    /* 判断必要的属性是否存在 */
    if ( !Reflect.has(payload, 'name') || !Reflect.has(payload, 'isSingle') ) return
    const { name, isSingle } = payload,
      keyName = isSingle ? 'userName' : 'groupId',
      { contactUserList, groupUserList } = store.state.chat.userListStu,
      targetData = isSingle ? contactUserList : groupUserList
    /* 判断当前name是否存在 */
    const localIndex = targetData.findIndex(item => item[keyName] === name)
    if ( !isSingle && localIndex === - 1 ) throw new Error('聊天群不存在')

    /* 避免多端同步 发消息造成混乱 */
    if ( isSingle ) {
      const localName = JSON.parse(localStorage.getItem('userInfo'))['userId']
      if ( localName === name ) return
    }

    /* 判断是否是新添加的用户 --只有单聊会出现 */
    if ( isSingle && (targetData.length === 0 || localIndex === - 1) ) {
      let resultData = await context.dispatch('addSingleUserStu', payload)

      const singleChatSortHandle = () => {
        if ( typeof resultData !== 'object' ) return
        resultData['name'] = name
        resultData['userName'] = name
        context.commit('sortUserStuList', { resultData, addUser: true })
      }

      /*判断路由 如果不是单聊或群聊，就不执行 */
      const i = router.history.current;
      if (i.path.indexOf('/messageManage') == -1) {
        singleChatSortHandle()
        return
      }

      if (singleCase.__chatType__ !='all') {
        Message.success('有新用户聊天,点击全部查看')
        return
      }

      singleChatSortHandle()
      return
    }
    isSingle ? context.commit('sortUserStuList', {
      name,
      otherOptions: payload.otherOptions,
      addUser: false
    }) : context.commit('sortGroupStuList', { groupId: name })
  },

  /**
   * @author lihh
   * @description 添加单个用户信息
   * @param {*} param0
   * @param {*} payload
   */
  async addSingleUserStu({}, payload) {

    // 解构数据
    let jobId = null
    const { name: userId, otherOptions = null } = payload
    if ( otherOptions && otherOptions['jobId'] ) jobId = otherOptions['jobId']
    // 添加用户信息
    const res = await saveRoster({ userId, jobId })
    // 判断请求是否成功
    if ( res.code != 200 ) {
      return false
    }
    return res.data
  },

  /**
   * @author lihh
   * @description 主要针对从别的页面 点击按钮 迁移过来的用户 直接跳转到聊天页面
   * @param {*} param0 vuex内置方法
   * @param {*} payload userName jobId
   */
  async skipPageAddSingleUserStu(context, payload) {
    /* 判断userName是否传递 */
    if ( !Reflect.has(payload, 'userName') ) throw new Error('页面迁移{userName}必须的')

    /* 获取对象中的属性 */
    const { userName, jobId = null } = payload,
      { contactUserList = [] } = store.state.chat.userListStu

    /* 判断缓存中是否存在当前用户 */
    const localIndex = contactUserList.findIndex(item => item.userName === userName)
    if ( localIndex !== - 1 ) {
      // 表示可以直接跳转页面了 缓存有值 ,更新职位后 放心跳转
      context.dispatch('updateJob', { name: userName, positionId: jobId })
      return true
    }

    /*
      1. 如果运行到这里表示缓存中没值 又分为两种情况
      2. 从来不是好友 需要添加好友 跳转页面 缓存中保存值
      3. 是好友 查询信息 保存缓存
    */
    const userInfo = await context.dispatch('addSingleUserStu', { name: userName, otherOptions: { jobId } })
    userInfo['name'] = userName
    userInfo['userName'] = userName
    if ( jobId ) userInfo['positionId'] = jobId
    context.dispatch('getHistoryMessage', { name: userName, isGroup: false })
    context.commit('skipPageAddSingleUserStu', userInfo)
    return true
  },

  /**
   * @description 主要针对从别的页面 点击按钮 初次发送聊天，包括卡片和第一次沟通
   * @param {*} param0 vuex内置方法
   * @param {*} payload userName jobId
   */

  async AddSingleUserToChat(context, payload) {
    /* 判断userName是否传递 */
    if (!Reflect.has(payload, "userName")) throw new Error("页面迁移{userName}必须的");
    const { userName,jobId,positionName, isFrist} = payload;
    context.dispatch("onSendText", { chatType:'contact', chatId:userName, message:`${jobId}`, positionId:jobId,langType:'113'});
    
    if (isFrist =='1') {
      let res = await getCommonWords()
      if (res.code =='200') {
        let firstName = res.data[0].content.replace('xxx',positionName)
        context.dispatch("onSendText", { chatType:'contact', chatId:userName, message:`${firstName}`, positionId:jobId });
      } else {
        context.dispatch("onSendText", { chatType:'contact', chatId:userName, message:`您好，我对贵公司职位【${positionName}】非常感兴趣，请问可以聊聊吗?`, positionId:jobId });
      } 
     } else {
      context.dispatch("onSendText", { chatType:'contact', chatId:userName, message:`我向您投递了简历`, positionId:jobId,langType:'12'});
     }
    
  },

  /**
   * @author lihh
   * @description 主要针对从别的页面 点击按钮 迁移过来的用户 直接跳转到群聊页面
   * @param {*} param0 vuex内置方法
   * @param {*} payload userName jobId
   */
  async skipPageAddGroup(context, payload) {
    /* 判断groupId是否传递 */
    if ( !Reflect.has(payload, 'groupId') ) throw new Error('页面迁移{groupId}必须的')

    /* 获取对象中的属性 */
    const { groupId } = payload,
      { groupUserList = [] } = store.state.chat.userListStu

    /* 判断缓存中是否存在当前群 */
    const localIndex = groupUserList.findIndex(item => item.groupId === groupId)
    if ( localIndex !== - 1 ) {
      return true
    }

    /*
      1. 如果运行到这里表示缓存中没值 又分为两种情况
      2. 从来没有加入群 需要添加群 跳转页面 缓存中保存值
      3. 是群成员 查询信息 保存缓存
    */
    const res = await context.dispatch('addSingleGroupStu', { name: groupId })
    if ( !res ) throw new Error('必须先加入群聊后获取群信息')
    const groupInfo = await context.dispatch('getGroupInfoStu', { name: groupId })
    groupInfo['groupId'] = groupId
    context.commit('skipPageAddGroupStu', groupInfo)
    return true
  },

  /**
   * @author lihh
   * @description 添加单个群信息
   * @param {*} payload
   */
  async addSingleGroupStu({}, payload) {
    const { name: groupId } = payload
    // 添加用户信息
    const res = await joinGroup(groupId)
    // 判断请求是否成功
    if ( res.code != 200 && res.code != 20099 ) {
      return false
    }
    return true
  },

  /**
   * @author lihh
   * @description 获取单个群信息
   * @param {*} payload
   */
  async getGroupInfoStu({}, payload) {
    const { name: groupId } = payload
    // 添加用户信息
    const res = await getGroup(groupId)
    // 判断请求是否成功
    if ( res.code != 200 ) {
      return false
    }
    return res.data
  },

  // 获取HR的个人详情
  async getHrInfos(context, payload) {
    const { name: userId } = payload
    const res = await getRosterById({ userId })
    // 判断请求是否成功
    if ( res.code != '200' ) {
      return false
    }
    context.commit('getHrInfos', res.data)
  },

  // 点击不合适修改列表状态
  editUserStatus(context, payload) {
    context.commit('editUserStatus', payload)
  },

  onGetContactUserList: function(context, payload) {
  },
  onGetGroupUserList: function(context, payload) {
    let options = {
      success: function(resp) {
        let userListStu = resp.data
        userListStu.forEach((user, index) => {
          userListStu[index].name = user.groupname
        })
        context.commit('updateUserList', {
          userListStu,
          type: 'groupUserList'
        })
      },
      error: function(e) {
      }
    }
    WebIM.conn.getGroup(options)
  },
  onGetChatroomUserList: function(context, payload) {
    var option = {
      apiUrl: 'https://a1.easemob.com',
      pagenum: 1,
      pagesize: 20,
      success: function(list) {
        context.commit('updateUserList', {
          userListStu: list.data,
          type: 'chatroomUserList'
        })
      },
      error: function() {
        console.log('List chat room error')
      }
    }
    WebIM.conn.getChatRooms(option)
  },

  /**
   * @author lihh
   * @description 获取当前群 或是 用户聊天消息
   * @param context store上下文
   * @param payload 传递数据
   */
  onGetCurrentChatObjMsg: function(context, payload = {}) {
    /* 解构类型 type=group 获取群聊消息 反之单聊 */
    const { type = 'group' } = payload,
      id = localStorage.getItem('currentId')

    /* 判断是否为空 */
    if ( !id || id == '' ) return
    context.commit('updateCurrentMsgList', context.state.msgListStu[type][id])
  },

  /**
   * @author lihh
   * @description 更新群消息
   * @param context 表示store上下文
   * @param payload 传递数据
   * */
  updateGroupInfo(context, payload) {
    // 限制更新字段
    const fields = [ 'isDisturb', 'isTop', 'groupId' ]
    // 字段存在判断
    let fieldExistFlag = Object.keys(payload).some(item => fields.includes(item))
    if ( !fieldExistFlag ) {
      throw new Error(`update field exlueds ${ fields.join(',') }`)
    }
    // 对置顶以及消息免打扰做 处理
    if ( Reflect.has(payload, 'isDisturb') ) {
      payload['isDisturb'] = payload['isDisturb'] ? 1 : 2
    }
    if ( Reflect.has(payload, 'isTop') ) {
      payload['isTop'] = payload['isTop'] ? 1 : 2
    }
    context.commit('updateGroupInfo', payload)
  },
  onSendText: function(context, payload) {
    // chatId 表示发送给谁 = 就是最后谁来接收
    // message 表示发送的消息
    let { chatType, chatId, message, positionId, langType = '1' } = payload
    const id = WebIM.conn.getUniqueId()
    const time = + new Date()
    const type = chatType === 'contact' ? 'singleChat' : 'groupChat'
    const msgObj = new WebIM.message('txt', id)
    // 发送消息 拼接格式:消息@@@类型@@@时间
    // 内容后面拼接特殊字符  1表示普通文本
    let messageArr = `${ message }@@@${ langType }@@@${ time }@@@${ positionId }`

    /* 如果消息类型是120 代表是引用 需要做特殊处理 */
    let [ selfMsg, quoteMsg, quoteMid ] = []
    if ( langType === '120' ) {
      [ selfMsg, quoteMsg, quoteMid ] = message.split('###')
      message = selfMsg
    }

    msgObj.set({
      msg: messageArr,
      to: chatId,
      chatType: type,
      roomType: false,
      success: function() {
        const mid = Array.from(arguments)[1]
        context.commit('updateMsgList', {
          chatType,
          chatId: chatId,
          msg: message,
          bySelf: true,
          quoteMsg,
          quoteMid,
          langType: langType,
          positionId: positionId,
          time: time,
          mid,
          status: 'unread'
        })
        // 修改列表显示顺序
        stuSortUserOrGroup(chatType, chatId)
      },
      fail: function(e) {
        console.log('Send private text error', e)
      }
    })
    //发送消息
    WebIM.conn.send(msgObj.body)
  },
  // 发送图片
  sendImgMessage: function(context, payload) {
    // 注：chatId存在name属性 是求职者 反之企业端
    const { chatType, chatId, roomType, file, callback } = payload
    const id = WebIM.conn.getUniqueId()
    const sendTime = + new Date()
    const msgObj = new WebIM.message('img', id)
    /* 访问路径 */
    let url = ''
    msgObj.set({
      apiUrl: WebIM.config.apiURL,
      file: file,
      to: chatId,
      roomType: roomType,
      ext: {
        time: sendTime
      },
      onFileUploadError: function(error) {
        console.log('图片上传失败', error)
        // callback();
      },
      onFileUploadComplete: function(data) {
        url = data.uri + '/' + data.entities[0].uuid
      },
      success: function() {
        const mid = Array.from(arguments)[1]
        context.commit('updateMsgList', {
          msg: url,
          chatType,
          chatId: chatId,
          bySelf: true,
          type: 'img',
          filename: file.filename,
          langType: '2',
          time: sendTime,
          mid,
          status: 'unread'
        })
        // 修改列表显示顺序
        stuSortUserOrGroup(chatType, chatId)
        callback()
        subscribeMsgNotice('send_picture')
      }
    })
    WebIM.conn.send(msgObj.body)
  },
  sendFileMessage: function(context, payload) {
    const { chatType, chatId, roomType, file, positionId, callback } = payload
    const id = WebIM.conn.getUniqueId()
    const msgObj = new WebIM.message('file', id)
    /* 请求路径 */
    let url = '',
      timestamp = ''
    msgObj.set({
      apiUrl: WebIM.config.apiURL,
      file: file,
      ext: {
        file_length: file.data.size,
        positionId
      },
      to: chatId,
      roomType: roomType,
      onFileUploadError: function(error) {
        console.log('文件上传失败', error)
        // callback();
      },
      onFileUploadComplete: function(data) {
        url = data.uri + '/' + data.entities[0].uuid
        timestamp = data.timestamp
      },
      success: function() {
        const mid = Array.from(arguments)[1]
        context.commit('updateMsgList', {
          msg: url,
          chatType,
          chatId: chatId,
          bySelf: true,
          type: 'file',
          filename: file.data.name,
          file_length: file.data.size,
          time: timestamp,
          positionId,
          langType: '5',
          mid,
          status: 'unread'
        })
        callback()
        /* 进行排序 */
        stuSortUserOrGroup(chatType, chatId)
      }
    })

    WebIM.conn.send(msgObj.body)
  },
  // 发送语音
  sendRecorder: function(context, payload) {
    // 解构数据
    const { token, dataObj, tempFilePath, dur: length, from, to } = payload
    const id = WebIM.conn.getUniqueId(),
      url = dataObj.uri + '/' + dataObj.entities[0].uuid
    const msgObj = new WebIM.message('audio', id)
    msgObj.set({
      apiUrl: config.apiURL,
      accessToken: token,
      body: {
        type: 'audio',
        url,
        filetype: '',
        filename: tempFilePath,
        accessToken: token,
        length
      },
      from,
      to,
      roomType: false,
      chatType: 'singleChat',
      success: () => {
        const mid = Array.from(arguments)[1]
        context.commit('updateMsgList', {
          msg: url,
          chatType: 'contact',
          chatId: to,
          bySelf: true,
          type: 'audio',
          length,
          filename: '语音',
          langType: '3',
          mid,
          status: 'unread'
        })
        /* 进行排序 */
        stuSortUserOrGroup('contact', to)
      }
    })
    WebIM.conn.send(msgObj.body)
  },

  onCallVideo: function(context, payload) {
    console.log(payload)
    const { chatType, to } = payload
    const type = chatType === 'contact' ? 'singleChat' : 'groupChat'
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if ( chatType === 'contact' ) {
      // this.setState({
      //     showWebRTC: true
      // })
      WebIM.call.caller = userInfo.userId
      WebIM.call.makeVideoCall(to, null, payload.rec, payload.recMerge)
    }
  },

  // 获取历史消息
  getHistoryMessage: async function(context, payload) {
    /* 数据判断 */
    if ( typeof payload.count !== 'number' ) payload['count'] = 10
    /* 查询未读个数 */
    const readCount = !payload.isGroup ? await mixinMsgUnreadNum({ id: payload.name }) : 0,
      commonReadFun = (length, label) => Array.from({ length }, () => label)
    let unreadArr = []
    /* 进行额外的判断 如果记录中存在表示翻页 翻页就是已读 但是-1除外 */
    if ( readCount === - 1 || (!getUserUnreadRecords(payload.name)) && readCount !== 0 ) {
      updateUserUnreadMsgRecords(payload.name, readCount)
      /* 如果结果是-1的话 表示都是未读 */
      if ( readCount === - 1 ) {
        unreadArr = commonReadFun(payload.count, 'read')
        context.commit("editUserOrGroupUnreadNum", {id: payload.name, type: payload.isGroup ? 'group' : 'contact'})
      }
      if ( readCount >= payload.count ) {
        payload.count = readCount
        unreadArr = commonReadFun(payload.count, 'unread')
      }
      if ( readCount < payload.count && readCount !== - 1 ) {
        const surplus = payload.count - readCount
        unreadArr = commonReadFun(surplus, 'read').concat(commonReadFun(readCount, 'unread'))
      }
    } else {
      unreadArr = commonReadFun(payload.count, 'read')
    }

    // 表示不同类型的消息设定
    const msgSetting = (msgs, name) => {
      // 获取用户信息
      const userInfo = JSON.parse(localStorage.getItem('userInfo')),
        userId = userInfo && userInfo.userId,
        len = msgs.length

      /* 将已经存在的数据拼装成为数组 */
      let msgType = payload.isGroup ? 'group' : 'contact'
      const existMsg = store.state['chat']['msgListStu'][msgType][name],
        msgInfo = []
      if ( Array.isArray(existMsg) ) {
        existMsg.forEach(item => msgInfo.push(`${ item.msg }@@@${ item.time }`))
      }

      const commonMsgHandle = data => data ? data.indexOf('@@@') == - 1 ? [ data, '1', + new Date(), '' ] : data.split('@@@') : [ '' ]

      // 防止查询的消息个数 跟已读未读数组个数不匹配
      if ( unreadArr.length !== msgs.length ) {
        unreadArr = unreadArr.slice(unreadArr.length - msgs.length)
      }
      msgs.forEach((item, key) => {
        let time = Number(item.time)
        let msg = {}
        const bySelf = item.from == userId,
          status = payload.isGroup || unreadArr.length === 0 ? 'read' : unreadArr.shift()

        // 表示普通文本消息  langType = 1
        if ( !item.filename ) {

          // 解构消息 类型 时间戳
          let data = item.data
          let [ messages, langType, times, otherArr ] = commonMsgHandle(data)
          /* 1判断是否存在相同的消息 */
          if ( msgInfo.includes(`${ messages }@@@${ times }`) ) return true
          /* 2. 只有消息重复而且是特别的消息 同样处理重复消息 -- 如果出现内容重复的数据 按一条来处理 */
           if ( len > 1 && key < (len - 1) ) {
            const [ curMsg ] = commonMsgHandle(data),
                [ nextMsg ] = commonMsgHandle(msgs[key + 1].data);
            if ( curMsg === nextMsg ) return true;
          }

          /* 针对消息类型是120做特殊的处理 */
          let [ selfMsg, quoteMsg, quoteMid ] = []
          if ( langType === '120' ) {
            [ selfMsg, quoteMsg, quoteMid ] = messages.split('###')
            messages = selfMsg
          }
          msg = {
            chatType: payload.isGroup ? 'group' : 'contact',
            chatId: bySelf ? item.to : item.from,
            msg: messages,
            quoteMsg,
            quoteMid,
            /* 暂时显示群聊名称 */
            otherArr,
            langType,
            bySelf: bySelf,
            time: times,
            mid: item.id,
            status
          }
          if ( payload.isGroup ) {
            msg.chatId = item.to
            // 判断谁给我发的消息
            if ( !bySelf ) {
              msg.from = item.from
            }
          } else {
            msg.chatId = bySelf ? item.to : item.from
          }
        }

        // 表示图片的场合  langType = 2
        else if ( !item.ext.file_length && item.filename !== 'audio' && item.filename.substring(item.filename.length - 3) !== 'mp4' ) {
          // 解构消息 类型 时间戳
          let extTime = item.ext.time || + new Date()
          let [ messages, langType, times ] = [ item.url, '2', extTime ]
          /* 判断是否存在相同的消息 */
          if ( msgInfo.includes(`${ messages }@@@${ times }`) ) return true
          msg = {
            msg: item.url,
            chatType: payload.isGroup ? 'group' : 'contact',
            chatId: bySelf ? item.to : item.from,
            bySelf: bySelf,
            langType,
            type: 'img',
            time: time,
            mid: item.id,
            status
          }
          if ( payload.isGroup ) {
            msg.chatId = item.to
          } else {
            msg.chatId = bySelf ? item.to : item.from
          }
        }

        // 为视频的场合 langType = 3
        else if ( item.filename === 'audio' ) {
          msg = {
            msg: item.url,
            chatType: payload.isGroup ? 'group' : 'contact',
            chatId: bySelf ? item.to : item.from,
            langType: '3',
            bySelf: bySelf,
            type: 'audio',
            status
          }
          if ( payload.isGroup ) {
            msg.chatId = item.to
          } else {
            msg.chatId = bySelf ? item.to : item.from
          }
        }

        // map4的场合
        else if ( item.filename.substring(item.filename.length - 3) === 'mp4' ) {
          msg = {
            msg: item.url,
            chatType: payload.isGroup ? 'group' : 'contact',
            chatId: bySelf ? item.to : item.from,
            langType: '4',
            bySelf: bySelf,
            type: 'video',
            status
          }
          if ( payload.isGroup ) {
            msg.chatId = item.to
          } else {
            msg.chatId = bySelf ? item.to : item.from
          }
        } else {
          msg = {
            msg: item.url,
            chatType: payload.isGroup ? 'group' : 'contact',
            chatId: bySelf ? item.to : item.from,
            bySelf: bySelf,
            type: 'file',
            langType: '5',
            filename: item.filename,
            file_length: item.file_length,
            time: time,
            mid: item.id,
            status
          }
          if ( payload.isGroup ) {
            msg.chatId = item.to
          } else {
            msg.chatId = bySelf ? item.to : item.from
          }
        }
        msg.isHistory = true
        context.commit('updateMsgList', msg)
      })
    }
    // 设置请求参数
    const options = {
      // 用户id
      queue: payload.name,
      // 表示是否分组
      isGroup: payload.isGroup,
      // 表示查询条数
      count: Reflect.has(payload, 'count') ? payload.count : 10, // 每次获取消息条数,
      success: function(msgs) {
        try {
          // payload.success && payload.success(msgs);
          Promise.resolve().then(() => payload.callback && payload.callback())
          /* 判断是否还有更多数据 */
          context.dispatch('updateNextPageStatus', {
            type: payload.isGroup ? 'group' : 'single',
            name: payload.name,
            nextPage: msgs.length >= 10
          })
          if ( msgs.length ) {
            // 设置不同分类的消息
            msgSetting(msgs, payload.name)
          }
          /* 取消聊天的加载中 */
          if ( store.getters.moreMsgLoadingStatus )
            asyncQueueFlush(() => store.commit('editMoreMsgLoadingStatus', payload), 'macro', 400)
        } catch ( e ) {
          console.log('error', e)
        }
      },
      fail: function() {
      }
    }
    WebIM.conn.fetchHistoryMessages(options)
  },
  // 消息撤回功能
  recallMessage: function({ commit }, payload) {
    const { mid, to, name } = payload
    let recallType = name == 'contact' ? 'chat' : 'groupchat'
    const option = {
      mid,
      to,
      type: recallType,
      success: function() {
        payload.status = 'recall'
        payload.langType = '12'
        payload.msg = '消息已撤回'
        commit('updateMessageStatus', { ...payload, isRecall: true })
      },
      fail: function() {
        Message.error('2分钟已过,消息撤回失败')
      }
    }
    WebIM.conn.recallMessage(option)
  }
}



// WEBPACK FOOTER //
// ./src/store/stu/actions.js